module.exports = __webpack_public_path__ + "static/img/logo-guomao.a9c5d88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-guomao.jpg
// module id = cUW/
// module chunks = 1